import React, {PureComponent} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {Container, Grid, GridColumn, Icon, Button} from "semantic-ui-react";
import MobileApplyNow from "./common/MobileApplyNow";
import ApplyNow from "./common/ApplyNow";
import EligibilityRequirements from "./common/EligibilityRequirements";

class Home extends PureComponent {
  static propTypes = {
    show: PropTypes.object.isRequired,
    page: PropTypes.object,
    season: PropTypes.object.isRequired,
  };


  constructor(props) {
    super(props);
    this.state = {
      visible: false,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  static defaultProps = {
    page: null,
  };

  toggleVisibility = () => this.setState({ visible: !this.state.visible });

  closeMenu = () => this.setState({ visible: false });

  renderTips(tips) {
    return (
      <GridColumn className="ui sixteen wide mobile five wide computer right floated tablet-up">
        <div className="ui fluid card noShadow tip">
          <div
            className="content invertedPrimary"
            style={{ backgroundColor: `#${this.props.season.hexColorCodeC}` }}
          >
            <div className="header">
              <h4>Tip</h4>
            </div>
          </div>
          <style jsx>
            {`
                 a {color: red;}
            `}
          </style>
          <div
            className="content shaded padded"
            dangerouslySetInnerHTML={{ __html: tips }}
          />
        </div>
      </GridColumn>
    );
  }

  fixPageContent(pageContent) {
    pageContent = pageContent.split("target=\"_blank\"");

    for (let content in pageContent) {
      if (pageContent.length !== parseInt(content) + 1 && !pageContent[content].includes("mailto:")) {
        pageContent[content] += "target=\"_blank\"";
      }
    }

    return pageContent.join();
  }

  render() {
    const { show, page, season } = this.props;
    const tips = page && page.tipsC ? this.renderTips(page.tipsC) : '';
    let pageContent = '';
    if (page && page.pageContentC) {
      pageContent = this.fixPageContent(page.pageContentC);
    }

    if (page) {
      return (
        <div>

          <Container id="mainContent" className="ui">
            <Grid className="ui">
              <GridColumn className="pageShowTitle">
                <h3
                  className="ui dividing header"
                  style={{ color: `#${season.hexColorCodeC}` }}
                >
                  {show.name} Casting
                </h3>
                  <Button
                    onClick={this.toggleVisibility}
                    id="applyToggle"
                    className="tiny ui primary tablet-down mobileToggle"
                  >
                    <Icon className="sidebar" />
                    Apply Now
                  </Button>
              </GridColumn>
            </Grid>

            <MobileApplyNow
              season={season}
              visible={this.state.visible} toggleVisibility={this.toggleVisibility} />

            <Grid className="ui stackable" onClick={this.closeMenu}>
              <GridColumn className="ui sixteen wide mobile eight wide computer">
                <h1>{page.pageTitleC}</h1>

                <p className="lead">{page.leadParagraphC}</p>

                <style>{"\
                .inner-html a {\
                  color:#" + season.hexColorCodeC + " !important;\
                }\
              "}</style>

                <div className="inner-html" dangerouslySetInnerHTML={{ __html: pageContent}} />

                <div className="ui hidden padded divider" />

                <EligibilityRequirements hexColorCodeC={season.hexColorCodeC} />
              </GridColumn>

              <ApplyNow
                season={season}
              />

              {tips}
            </Grid>
          </Container>
        </div>
      );
    }
    return <div />;
  }
}

const mapStatesToProps = (state, ownProps) => ownProps;

export default connect(mapStatesToProps)(Home);



// WEBPACK FOOTER //
// ./src/components/Home.js